import React from 'react'
import {
  CardCategoryFaqs as CardCategory,
  CardResultFaqs,
  EmptyResults,
  ResultText,
} from '../components'
import { HelpGroupCardLoader } from '../../shared/components/loaders/HelpGroupCardLoader'
import { useArticles } from '../context/ArticlesContext'
import { useNavigate } from 'react-router-dom'
import { buildHelpUri } from '../utilities/buildUri'

export const FaqsHome = () => {
  const navigate = useNavigate()
  const { searched, categories } = useArticles()

  const {
    data: searchedArticles,
    isLoading: isLoadingSearch,
    term,
  } = searched || {}
  const { data: categoriesData, isLoading: isLoadingCategories } =
    categories || {}

  const isLoading = term ? isLoadingSearch : isLoadingCategories
  const hasSearch = term && searchedArticles && !!searchedArticles?.length
  const noResults = term && searchedArticles && !searchedArticles?.length

  const handleNavigateToCategory = (slugCategory: string) => {
    if (!slugCategory) return null

    const categoryUri = buildHelpUri(slugCategory)['category']
    return navigate(categoryUri)
  }

  const handleNavigateToArticle = (article: string) => {
    if (!article) return null

    const articleUri = buildHelpUri(article)['article']
    return navigate(articleUri)
  }

  return (
    <>
      {term && <ResultText searchValue={term} />}
      {isLoading && <HelpGroupCardLoader />}
      {hasSearch
        ? searchedArticles.map(article => (
            <CardResultFaqs
              key={article.id}
              name={article.title}
              body={article.description}
              image={article.urlImage}
              slug={article.slug}
              onClick={handleNavigateToArticle}
            />
          ))
        : !term &&
          categoriesData &&
          categoriesData.map(category => (
            <CardCategory
              key={category.id}
              name={category.name}
              body={category.description}
              image={category.urlImage}
              slug={category.slug}
              onClick={handleNavigateToCategory}
            />
          ))}
      <EmptyResults
        text={'No hay resultados disponibles 🔍'}
        isShowed={!!noResults}
      />
    </>
  )
}
